module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "snack-bar",
    staticClass: "mdl-js-snackbar mdl-snackbar"
  }, [_c('div', {
    staticClass: "mdl-snackbar__text"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-snackbar__action",
    attrs: {
      "type": "button"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1de6e5f9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/SnackBar.vue
// module id = 1080
// module chunks = 38